<section>
  @if (isUnified) {
  <h1 *ngIf="result.type === pageType.Custom || titleKey" class="uc-display-xs uc-medium">
    <ng-container *ngIf="notFound; else pageTitle">{{ 'emptyState.pageNotFound' | translate }}</ng-container>
    <ng-template #pageTitle>
      <ng-container *ngIf="result.type === pageType.Custom; else titleFromKey">{{ isRtl ? result.titleAr : result.title }}</ng-container>
    </ng-template>
    <ng-template #titleFromKey>{{ titleKey | translate }}</ng-template>
  </h1>
  } @else {
  <h3 *ngIf="result.type === pageType.Policy" translate="footer.privacy"></h3>
  <h3 *ngIf="result.type === pageType.Terms" translate="footer.generalTerms"></h3>
  <h3 *ngIf="result.type === pageType.AboutUs" translate="footer.about_us"></h3>
  <h3 *ngIf="result.type === pageType.UserGuide" translate="footer.userGuide"></h3>
  <h3 *ngIf="result.type === pageType.TraineeGuide" translate="footer.traineeGuide"></h3>
  <!-- <h3 *ngIf="result.type === pageType.OurTeam" translate="footer.ourTeam"></h3> -->
  <h3 *ngIf="result.type === pageType.Custom && !notFound">{{isRtl? result.titleAr : result.title }}</h3>
  <h3 *ngIf="notFound" translate="emptyState.pageNotFound"></h3>
  }
  <div class="container">
    <div #content></div>
    <!-- The CMS page exists but carries no published body yet; say so instead of showing a blank page. -->
    <p *ngIf="loaded && !hasContent && !notFound" class="text-center text-muted py-5 mb-0" translate="emptyState.noContent"></p>
    <!-- Unknown CMS page id: the heading above names the state; the not-found sentence and a link home follow. -->
    <app-not-found-state *ngIf="notFound" messageKey="emptyState.profileNotFoundMessage" linkKey="emptyState.backToHome"
      link="/home"></app-not-found-state>
    <!-- <app-our-team *ngIf="result.type === pageType.OurTeam"></app-our-team> -->
  </div>
</section>